/* eslint-disable react/forbid-prop-types */
import PropTypes from 'prop-types';
import { PureComponent } from 'react';

import Field from 'Component/Field';
import FIELD_TYPE from 'Component/Field/Field.config';

/** @namespace Bodymod/PostNord/Component/PostNordPoint/Component */
export class PostNordPointComponent extends PureComponent {
    static propTypes = {
        point: PropTypes.object.isRequired,
        onClick: PropTypes.func.isRequired,
        selectedPoint: PropTypes.string.isRequired
    };

    renderPoint() {
        const {
            point: {
                name, address, zipcode, city, carrier_code, number, id
            },
            onClick,
            selectedPoint
        } = this.props;

        return (
            <li block="CheckoutDeliveryOption" index={ `option-${ number }` }>
            <button
              block="CheckoutPayment"
              mods={ false }
              elem="Button"
              type="button"
              onClick={ onClick }
            >
                <Field
                  type={ FIELD_TYPE.radio }
                  attr={ {
                      id: `option-${ number }`,
                      name: `option-${ number }`,
                      checked: selectedPoint === id
                  } }
                />
                <ul>
                    <li block="CheckoutPayment" elem="title">{ name }</li>
                    <li>{ address }</li>
                    <li>{ zipcode }</li>
                    <li>{ city }</li>
                    <li>{ `ID: ${carrier_code}-${number}` }</li>
                </ul>
            </button>
            </li>
        );
    }

    render() {
        return this.renderPoint();
    }
}

export default PostNordPointComponent;
